<template>
  <div>
    <v-layout row wrap class="ma-0 pa-0">
      <v-flex xs12>
        <div class="px-4 pb-3 my-4">
          <v-btn style="position: absolute; top: 0px; right: 5px" @click="$emit('close')" icon>
            <v-icon>close</v-icon>
          </v-btn>

          <div>
            <v-layout row wrap>
              <v-flex xs12>
                <div style="font-size: 20px; font-weight: 600" class="mb-3 primary--text">
                  ข้อมูลส่วนตัว
                </div>
              </v-flex>
              <v-flex xs12 sm6 class="py-1">
                <div>
                  <span class="primary--text">ชื่อ-สกุล:</span>
                  <span>{{ memberData.name }}</span>
                </div>
              </v-flex>
              <v-flex xs12 sm6 class="py-1">
                <div>
                  <span class="primary--text">วันเกิด:</span>
                  <span>{{ getDateFormatted(memberData.dob) }}</span>
                </div>
              </v-flex>
              <v-flex xs12 sm6 class="py-1">
                <div>
                  <span class="primary--text">อายุ:</span>
                  <span>{{ memberData.ages }}</span>
                </div>
              </v-flex>

              <v-flex xs12 sm6 class="py-1">
                <div>
                  <span class="primary--text">เพศ:</span>
                  <span>{{ memberData.gender }}</span>
                </div>
              </v-flex>
              <!-- v-if="this.$store.state.privilege && this.$store.state.privilege.role !== 'staff'" -->
              <template>
                <v-flex xs12 sm6 class="py-1">
                  <div>
                    <span class="primary--text">เบอร์ติดต่อ:</span>
                    <span>{{ memberData.phone_number }}</span>
                  </div>
                </v-flex>
                <v-flex xs12 sm6 class="py-1">
                  <div>
                    <span class="primary--text">อีเมล:</span>
                    <span>{{ memberData.email }}</span>
                  </div>
                </v-flex>
              </template>
            </v-layout>
          </div>

          <div class="mt-4">
            <div style="font-size: 20px; font-weight: 600" class="mb-3 primary--text">
              ข้อมูลการซื้อ
            </div>
            <div class="mt-2 mb-1 text-xs-right">
              <v-pagination
                :total-visible="6"
                v-model="pageNumber"
                @input="changePage"
                :length="pagelength"
              ></v-pagination>
            </div>
            <v-data-table
              hide-actions
              :headers="headers"
              :items="dataMemberDetail"
              :pagination.sync="pagination"
              :loading="loading"
              class="elevation-1"
            >
              <template v-slot:items="props">
                <tr>
                  <td>{{ props.item.warranty_number }}</td>
                  <td>{{ props.item.sku }}</td>
                  <td>{{ props.item.name }}</td>
                  <td>{{ props.item.amounts | numberFormat }}</td>
                  <td>{{ props.item.types }}</td>
                </tr>
              </template>
            </v-data-table>
          </div>
        </div>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import api from '@/api'
import { mapGetters } from 'vuex'
import moment from 'moment'

export default {
  props: ['memberData'],
  components: {},
  data() {
    return {
      loading: false,
      offset: 0,
      limit: 10,
      pagination: { rowsPerPage: -1, sortBy: '' },
      pagetmp: 1,
      pageNumber: 1,
      total: 0,
      headers: [
        { text: 'หมายเลขรับประกันสินค้า', value: 'timestamp', width: '2%', sortable: false },
        { text: 'รหัสรุ่นสินค้า', value: 'product', width: '2%', sortable: false },
        { text: 'สินค้า', value: 'quantity', width: '2%', sortable: false },
        { text: 'ยอดซื้อ', value: 'price', width: '2%', sortable: false },
        { text: 'Gift / Purchase', value: 'shippingcharge', width: '2%', sortable: false }
      ],
      dataMemberDetail: []
    }
  },
  computed: {
    ...mapGetters(['selectedBot']),
    pageid() {
      return this.selectedBot.pageid
    },
    pagelength() {
      if (this.total) {
        var total = parseFloat(this.total)
        return Math.ceil(total / this.limit)
      } else {
        return 1
      }
    }
  },
  mounted() {
    this.getMembershipDetails(this.memberData.id)
  },
  methods: {
    getMembershipDetails(id) {
      var vm = this
      var data = {
        pageid: vm.pageid,
        member_id: id,
        limit: vm.limit,
        offset: vm.offset
      }
      this.loading = true
      api.getLamyMembershipHistory(data, (err, response) => {
        if (response.responsecode == 200) {
          vm.dataMemberDetail = response.data
          vm.total = response.total
          this.loading = false
        } else {
          console.log(err)
          return
        }
      })
    },
    getDateFormatted(val) {
      if (val) {
        return moment(val).format('DD/MM/YYYY')
      } else {
        return ''
      }
    },
    changePage(val) {
      var vm = this
      if (this.pagetmp == val) {
        //dont do shit
      } else {
        this.pagetmp = val
        vm.offset = vm.pageNumber * this.limit - this.limit

        this.getMembershipDetails(this.memberData.id)
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/lamy/MembershipDetails.vue